import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class LoaderService {
	public isLoading: Subject<boolean>;

	constructor() {
		this.isLoading = new Subject();
	}

	showLoader() {
		this.isLoading.next(true);
	}

	hideLoader() {
		this.isLoading.next(false);
	}
}
